import React from "react";
import {
  RideGlStarSolid,
  RideGlPinSolid,
  RideGlCoverageSolid,
  RideGlPremiumHealthSolid,
  RideGlMoneySolid,
  RideIcWalletLight,
  RideIcProtectionLight,
  RideIcCoinLight,
  RideGlLifeInvestmentSolid,
  RideFiDniErrorLight,
  RideFiInactivityLight,
  RideFiErrorCardLight,
  RideFiAvatarFLight,
  RideFiErrorLight,
  RideFiConnectionLight,
  RideGlUserSolid,
  RideIcFamilyLight,
  RideIcAddUserLight,
  RideGlInsuranceSolid,
  RideGlBusinessSolid,
  RideGlDollarSolid,
  RideGlProcessSolid,
  RideGlClockSolid,
  RideGlChatSolid,
  RideGlHeartSolid,
} from "@rimac-seguros/ride-system-components";

const ICONS = {
  RideGlStarSolid,
  RideGlPinSolid,
  RideGlCoverageSolid,
  RideGlPremiumHealthSolid,
  RideGlMoneySolid,
  RideIcWalletLight,
  RideIcProtectionLight,
  RideIcCoinLight,
  RideGlLifeInvestmentSolid,
  RideFiDniErrorLight,
  RideFiInactivityLight,
  RideFiErrorCardLight,
  RideFiAvatarFLight,
  RideFiErrorLight,
  RideFiConnectionLight,
  RideGlUserSolid,
  RideIcFamilyLight,
  RideIcAddUserLight,
  RideGlInsuranceSolid,
  RideGlBusinessSolid,
  RideGlDollarSolid,
  RideGlProcessSolid,
  RideGlClockSolid,
  RideGlChatSolid,
  RideGlHeartSolid,
};

const DynamicIcon = ({ icon, size = "medium", className }) => {
  const IconComponent = ICONS[icon];
  return IconComponent ? (
    <IconComponent size={size} className={className} />
  ) : null;
};

export default DynamicIcon;
